import React from "react";
import { Skeleton } from "@mui/material";
import cssExports from "theme/styles/main.module.scss";

const WidgetSkeleton: React.FC = () => {
  return <Skeleton className={cssExports.widgetSkeleton} width="100%" height="80%" sx={{ minHeight: 100 }} />;
};

export default WidgetSkeleton;
